import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopUp } from "../../../store/reducer";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

import { CustomModal, InputField, SearchComboBox } from "../../../components";
import API from "../../../axios";
import { errorsSetter } from "../../../helpers/errors-setter";
import myTranslator from "../../../helpers/myTranslator";


export default function UpdateManufacturer({
  id,
  setId,
  componentId,
  setComponentId,
  handleClose,
  getData = () => { },
}) {  
  const [isLoading, setIsLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const { selectedLang, translation } = useSelector((state) => state.storeReducer);  
  const [formData, setFormData] = useState({
    manufacturer: "",
    componentId: 0,
    component: "",
    status: true,
    _method: "patch",
  });

  const [formErrors, setFormErrors] = React.useState({});

  const dispatch = useDispatch();
  useEffect(() => {
    getManufacturer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getManufacturer = async () => {
    setGetLoading(true);
    try {
      const {data} = await API(
        `admin/component-types/${componentId}/manufacturers/${id}`,
        "get"
      );
      setFormData({
        ...formData,
        manufacturer: data?.manufacturer,
        status: data?.active,
        componentId: data?.component_type_id,
        component: data?.componenttypes?.title,
        componentType: data?.componenttypes,
      });
      setGetLoading(false);
    } catch (err) {
      setGetLoading(false);
      let obj = {
        message: err?.response?.message,
        type: "error",
      };
      dispatch(openPopUp(obj));
    }
  };

  const handleForm = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setFormErrors({});
    try {
      await API(
        `admin/component-types/${formData.componentId}/manufacturers/${id}`,
        "post",
        formData
      );
      setIsLoading(false);
      let obj = {
        message: myTranslator(translation,selectedLang,"sa_mnu_update_alert_success"),
        type: "success",
      };
      dispatch(openPopUp(obj));
      getData();
      handleClose(false);
    } catch (err) {
      if (err?.response?.status === 422) {
        setFormErrors(errorsSetter(err));
      } else {
        let obj = {
          message: err?.response?.message,
          type: "error",
        };
        dispatch(openPopUp(obj));
      }

      setIsLoading(false);
    }
  };

  return (
    <>
      <CustomModal
        handleClose={() => {
          handleClose();
          setId(null);
          setComponentId(null);
        }}
      >
        <Container maxWidth="100%">

          <Box>
            <Typography component="h6" variant="h6" textAlign="">
          
              {myTranslator(translation,selectedLang,"sa_mnu_update_manufacturer")}
            </Typography>
          </Box>
          {getLoading ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <CircularProgress size={30} />
            </Box>
          ) : (
            <form autoComplete="off" onSubmit={handleForm}>
              <Box mt={2} mb={3}>
                <InputField
                  placeholder={myTranslator(translation,selectedLang,"sa_mnu_update_label_title")}
                  size="small"
                  label={myTranslator(translation,selectedLang,"sa_mnu_update_lable_title")}
                  required
                  fullWidth
                  styles={{ mb: 2 }}
                  name="manufacturer"
                  value={formData?.manufacturer}
                  error={formErrors?.manufacturer}
                  handleChange={(e) =>
                    setFormData({ ...formData, manufacturer: e.target.value })
                  }
                />
                <SearchComboBox
                  record={formData.componentType}
                  url={"admin/component-types?non_custom=1&"}
                  fullWidth
                  required={false}
                  objLabel="title"
                  size="small"
                  handleChange={(e) => {
                    setFormData({
                      ...formData,
                      component: e.title,
                      componentId: e.id,
                    });
                  }}
                  label={myTranslator(translation,selectedLang,"sa_mnu_update_label_component_type")}
                  styles={{ mb: 2 }}
                />
                <Stack justifyContent="space-between" direction="row">
                  <label>{myTranslator(translation,selectedLang,"sa_mnu_update_label_status")}</label>
                  <Switch
                    checked={formData.status}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        status: e.target.checked ? 1 : 0,
                      })
                    }
                    color="success"
                  />
                </Stack>
                <Box sx={{ textAlign: "end" }}>
                  <Button
                    onClick={() => handleClose(false)}
                    sx={{
                      mt: 2,
                      mr: 1,
                    }}
                    type="button"
                  >
                    {myTranslator(translation,selectedLang,"sa_mnu_update_btn_cancel")}
               
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => { }}
                    sx={{
                      mt: 2,
                    }}
                    disabled={isLoading}
                    type="submit"
                  >
                    {isLoading ? (
                      <CircularProgress
                        size={18}
                        sx={{ color: "#fff", mr: 1, size: "12px" }}
                      />
                    ) : null}
                    
                    {myTranslator(translation,selectedLang,"sa_mnu_update_btn_update")}
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Container>
      </CustomModal>
    </>
  );
}

